<template>
    <div
        id="portfolio-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <base-button
            type="a"
            :href="data.voting"
            target="_blank"
            rel="noopener"
            design="secondary"
            width="unset"
            :disabled="true"
        >
            Voting is now closed.
        </base-button>
        <project-section heading="Year 1" :projects="getProjects('1')" />
        <project-section heading="Year 2" :projects="getProjects('2')" />
        <project-section heading="Year 3" :projects="getProjects('3')" />
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/portfolio.md';

    import ProjectSection from '../components/ProjectSection';

    export default {
        name: 'portfolio',

        mixins: [dataLoader(data)],

        components: {
            ProjectSection,
        },

        methods: {
            getProjects(year) {
                return this.data.projects.filter(
                    project => project.year === year
                );
            },
        },
    };
</script>

<style lang="scss" scoped>
    #portfolio-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        .button {
            text-align: center;
            padding: 0 20px;
            margin-bottom: 30px;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }
    }
</style>
